module.exports = __webpack_public_path__ + "img/accounting.9cbba4b3.svg";